<template>
  <div>
    <div class="row" id="inputsSMS">
      <div class="col-md-6">
        <label id="date_debut_lb" for="date">Date :</label>
        <datepicker
          class="form-control datepicker"
          :value="date"
          v-model="date"
          name="date"
          @selected="getBookings"
          :clearButton="false"
          format="yyyy-MM-dd"
          full-month-name
          monday-first
        ></datepicker>
      </div>
      <div class="col-md-2">
        <label>&nbsp;</label>
        <button
          type="button"
          class="btn btn-primary"
          @click="toggleSMSModal('show')"
          id="showSMSModalBtn"
          style="display: none"
        >
          <i class="far fa-comment"></i>
          <span>&nbsp;Envoi des SMS</span>
        </button>
      </div>
    </div>
    <table v-show="Object.keys(customersBookings).length > 0" id="customersBookingsTable" class="display compact">
      <thead>
        <tr>
          <th></th>
          <th>Contact</th>
          <th>Activité</th>
          <th>Heure de départ</th>
          <th>Notifications</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(event, eidx) in customersBookings">
          <tr v-if="event.booking != null">
            <td
              :data-bookingId="event.booking.id"
              :data-eidx="eidx"
              :data-hasPhone="event.booking.customer.phone != null"
            ></td>
            <td>{{ event.booking.customer.fullName }}</td>
            <td>{{ event.title }}</td>
            <td>{{ format(event.start, 'HH[h]mm') }}</td>
            <td :data-order="event.booking.notifications.length">
              <p v-for="notif in event.booking.notifications">
                {{ format(notif.created_at, 'DD[/]MM[/]YYYY à HH[h]mm') }} -
                {{ !notif.nexmo_responses ? 'pending' : notif.nexmo_responses }}
                <span
                  class="tooltips"
                  data-container="body"
                  data-placement="top"
                  data-html="true"
                  :data-original-title="'<div id=\'tooltip\'>' + notif.message + '</div>'"
                >
                  <i class="far fa-comment"></i>
                </span>
              </p>
            </td>
          </tr>
          <template v-else>
            <tr v-for="(group, gidx) in event.bookingmultiple.groups">
              <td
                :data-groupId="group.id"
                :data-eidx="eidx"
                :data-gidx="gidx"
                :data-hasPhone="group.contact.phone != null"
              ></td>
              <td>{{ group.contact.fullName }}</td>
              <td>{{ event.title }}</td>
              <td>{{ format(event.start, 'HH[h]mm') }}</td>
              <td :data-order="group.notifications.length">
                <p v-for="notif in group.notifications">
                  {{ format(notif.created_at, 'DD[/]MM[/]YYYY à HH[h]mm') }} -
                  {{ !notif.nexmo_responses ? 'pending' : notif.nexmo_responses }}
                  <span
                    class="tooltips"
                    data-container="body"
                    data-placement="top"
                    data-html="true"
                    :data-original-title="'<div id=\'tooltip\'>' + notif.message + '</div>'"
                  >
                    <i class="far fa-comment"></i>
                  </span>
                </p>
              </td>
            </tr>
          </template>
        </template>
      </tbody>
    </table>
    <div id="sms-modal" class="modal fade" role="dialog" style="z-index: 10056">
      <div class="modal-dialog">
        <form class="modal-content row" id="notifyForm">
          <div class="modal-header row col-md-10 col-md-offset-1">
            <h3 class="modal-title font-blue col-md-10 col-md-offset-1">Envoyer des SMS</h3>
          </div>
          <div class="modal-body col-md-10 col-md-offset-1">
            <br />
            <div v-if="customersWithoutPhone.length > 0" class="alert alert-warning">
              <b>Attention :</b>
              Les clients suivants ne disposent pas de numéro de téléphone, le SMS ne leur sera donc pas envoyé :
              <li v-for="customer in customersWithoutPhone">
                {{ customer.fullname }} pour "{{ customer.activity }}" le {{ customer.date }}
              </li>
            </div>
            <div class="form-group">
              <label>Message :</label>
              <textarea
                class="form-control"
                name="message"
                id="message"
                v-model="message"
                @focus="isMessageFocus = true"
                @blur="isMessageFocus = false"
              ></textarea>
              <div class="alert alert-warning" v-show="message == '' && isMessageFocus">
                <b>Attention :</b>
                Le message d’accompagnement engendre un surcoût qui vous sera facturé :
                {{ smsPrice }} € fois le nombre de destinataire et par tranche de 50 caractères
              </div>
              <div class="alert alert-warning" v-show="message != ''">
                <b>Estimation du surcoût : </b>{{ smsCount.totalPrice }} <b>Détail :</b
                >{{ smsCount.recipients }} destinataire x {{ smsCount.parts }} tranche de 50 caractères x
                {{ smsCount.partPrice }}
              </div>
            </div>
            <span v-for="(item, idx) in precomputedMsgs">
              <label class="mt-checkbox mt-checkbox-outline" :for="'precompute_' + idx"
                >{{ item.msg }}
                <input
                  type="checkbox"
                  class="form-check-input"
                  :id="'precompute_' + idx"
                  :name="'precompute_' + idx"
                  :true-value="item.msg"
                  v-model="precomputeChoice"
                />
                <span :style="'border-color:' + item.color"></span>
              </label>
            </span>
            <div v-show="computedMessage || message">
              <label>Exemple d'aperçu pour la première personne selectionnée :</label>
              <div class="row">
                <div class="col-md-1">
                  <i class="fas fa-user" id="senderIcon"></i>
                </div>
                <div class="col-md-10" id="messagePreview">
                  <p v-if="computedMessage" v-html="computedMessage"></p>
                  <p>{{ message }}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">Annuler</button>
            <input type="button" @click="sendSMS" class="btn green" value="Envoyer" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
moment.locale('fr');
export default {
  name: 'bookingNotification',
  props: ['datatableLocale', 'officeName', 'officePhone', 'smsPrice', 'selectedDate'],
  components: {
    Datepicker
  },
  data() {
    return {
      errors: {},
      date: null,
      customersBookings: [],
      precomputedMsgs: [
        {
          msg: 'ADRENALINE PARAPENTE confirme votre RDV du !date! à !time! au bureau au col de la Forclaz - 74290 Talloires Montmin',
          color: '#468b5c'
        },
        {
          msg: 'ADRENALINE PARAPENTE confirme votre RDV du !date! à !time! ZA de perroix 150 chemin de pré monteux - 74290 Talloires Montmin',
          color: '#468b5c'
        },
        {
          msg: "ADRENALINE PARAPENTE la météo ne nous permet pas à 100% d'assurer les vols, voulez-vous venir quand même ? SMS au 0659726958",
          color: '#c98570e0'
        },
        {
          msg: 'ADRENALINE PARAPENTE annule votre rdv du !date! pour cause météo. Rappelez au 0659480737 merci de votre compréhension',
          color: '#ff0000'
        }
      ],
      precomputeChoice: null,
      computedMessage: 'test',
      message: '',
      isMessageFocus: false,
      customersWithoutPhone: [],
      datatable: null,
      forceRecompute: 1 //smsCount doesn't recompute if datatable selected change. Multiply this by -1 to force it
    };
  },
  watch: {
    precomputeChoice: function (val) {
      this.setBookingComputedPreview();
    }
  },
  computed: {
    smsCount: function () {
      this.forceRecompute; //if this change, smsCount will be trigger
      let recipients = 0;
      if (this.datatable != null) {
        let rows = this.datatable.DataTable().rows({ selected: true });
        recipients = $(rows.nodes()).filter(function (idx, item) {
          return $(item).children('td:eq(0)').attr('data-hasPhone');
        }).length;
      }
      let SMSparts = Math.ceil(this.message.length / 50);
      let SMSPriceFormated = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(
        this.smsPrice
      );
      let total = recipients * SMSparts * this.smsPrice;
      total = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(total);
      return { recipients: recipients, parts: SMSparts, partPrice: SMSPriceFormated, totalPrice: total };
    }
  },
  mounted() {
    //attribuer selectedDate passé en parametre à la variable "date" et appeler getBookings pour charger les bookings de cette date
    if (this.selectedDate) {
      this.date = this.selectedDate;
      this.getBookings(this.date);
    }
  },
  methods: {
    format(date, format) {
      let mdate = moment(date);
      return mdate.format(format);
    },
    getBookings(date) {
      let vm = this;
      axios
        .get('/calendar/notify/getbookingcustomers/' + moment(date).format('YYYY-MM-DD'))
        .then(response => {
          this.destroyTable();
          this.customersBookings = response.data.events;
          this.$nextTick(function () {
            this.initTable();
            $('.tooltips').tooltip({
              html: true,
              template:
                '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner tooltip-large"></div></div>'
            });
          });
        })
        .catch(function (error) {
          console.log(error);
          vm.$snotify.error(error.response.statusText, 'Erreur ' + error.response.status, { timeout: 5000 });
        });
    },
    initTable() {
      this.datatable = $('#customersBookingsTable').dataTable({
        language: {
          url: this.datatableLocale,
          select: {
            rows: {
              _: '%d réservations sélectionnées',
              0: 'Cochez une ou plusieurs réservations pour envoyer',
              1: '1 réservation sélectionnée'
            }
          }
        },
        columnDefs: [
          { className: 'dt-right' },
          {
            className: 'select-checkbox',
            orderable: false,
            targets: 0
          }
        ],
        select: {
          style: 'multi',
          selector: 'td:first-child' //filter for interaction
        },
        order: [
          [3, 'asc'],
          [1, 'asc']
        ]
      });
      let table = $('#customersBookingsTable').DataTable();
      table
        .on('click', 'th.select-checkbox', function () {
          if ($(this).hasClass('selected')) {
            //if header check box deselected
            table.rows({ search: 'applied' }).deselect(); //deselect all
            $(this).removeClass('selected');
          } else {
            table.rows({ search: 'applied' }).select(); //else select all
            $(this).addClass('selected');
          }
        })
        .on('select deselect', function () {
          if (table.rows({ selected: true }).count() !== table.rows().count()) {
            $('th.select-checkbox').removeClass('selected');
          } else {
            $('th.select-checkbox').addClass('selected');
          }
        });
      let vm = this;
      this.datatable.on('select.dt deselect.dt', function (e, dt, type, indexes) {
        vm.forceRecompute *= -1;
        let rows = vm.datatable.DataTable().rows({ selected: true });
        $('#showSMSModalBtn').toggle(rows.count() > 0);
      });
    },
    destroyTable() {
      if (this.datatable != null) {
        this.datatable.off('click');
        this.datatable.off('select.dt deselect.dt');
        $('th.select-checkbox.selected').removeClass('selected');
        $('#customersBookingsTable').DataTable().rows({ search: 'applied' }).deselect();
        $('#customersBookingsTable').DataTable().destroy();
      }
    },
    setBookingComputedPreview() {
      let rows = this.datatable.DataTable().rows({ selected: true });
      let firstSelected = $(rows.nodes()[0]).children('td:eq(0)');
      let eventIdx = firstSelected.attr('data-eidx');
      //let groupIdx = firstSelected.attr('data-gidx')

      if (this.precomputeChoice) {
        let replacedMsg = this.replacePairs(this.precomputeChoice, {
          '!date!': this.format(this.customersBookings[eventIdx].start, 'DD/MM'),
          '!time!': this.format(this.customersBookings[eventIdx].start, 'HH:mm')
        });
        this.computedMessage = replacedMsg;
      } else {
        this.computedMessage = '';
      }
    },
    replacePairs(str, replaceBy) {
      for (let key in replaceBy) {
        str = str.replace(key, replaceBy[key]);
      }
      return str;
    },
    toggleSMSModal(display = 'toggle') {
      if ($('#sms-modal').modal(display)) {
        this.precomputeChoice = null;
        this.message = '';
        this.setBookingComputedPreview();
        this.checkCustomersWithoutPhone();
      }
    },
    checkCustomersWithoutPhone() {
      this.customersWithoutPhone = [];
      let rows = this.datatable.DataTable().rows({ selected: true });
      let selected = $.map(rows.nodes(), function (item) {
        return {
          eidx: $(item).children('td:eq(0)').attr('data-eidx'),
          gidx: $(item).children('td:eq(0)').attr('data-gidx'),
          hasphone: $(item).children('td:eq(0)').attr('data-hasPhone')
        };
      });
      for (let row of selected) {
        if (!row.hasphone) {
          let customer = {
            activity: this.customersBookings[row.eidx].title,
            date: this.format(this.customersBookings[row.eidx].start, 'DD/MM [à] HH:mm')
          };
          if (row.gidx) {
            customer.fullName = this.customersBookings[row.eidx].bookingmultiple.groups[row.gidx].contact.fullName;
          } else {
            customer.fullname = this.customersBookings[row.eidx].booking.customer.fullName;
          }
          this.customersWithoutPhone.push(customer);
        }
      }
    },
    sendSMS() {
      let rows = this.datatable.DataTable().rows({ selected: true });
      let bookingsIds = $.map(rows.nodes(), function (item) {
        return $(item).children('td:eq(0)').attr('data-bookingId');
      });
      let groupsIds = $.map(rows.nodes(), function (item) {
        return $(item).children('td:eq(0)').attr('data-groupId');
      });
      let vm = this;

      console.log(
        'bookingIds',
        bookingsIds,
        'groupIds',
        groupsIds,
        'customMessage',
        vm.message,
        'computedMessage',
        vm.precomputeChoice,
        'smsPrice',
        vm.smsPrice,
        'parts',
        vm.smsCount.parts
      );

      axios
        .post('/calendar/notify/send', {
          bookingIds: bookingsIds,
          groupIds: groupsIds,
          customMessage: vm.message,
          computedMessage: vm.precomputeChoice,
          smsPrice: vm.smsPrice,
          parts: vm.smsCount.parts
        })
        .then(response => {
          if (response.data.status == 'error') {
            vm.$snotify.error(response.data.statusText, { timeout: 5000 });
          } else {
            this.toggleSMSModal('hide');
            vm.getBookings(vm.date);
          }

          console.log(response);
        })
        .catch(function (error) {
          console.log(error);
          vm.$snotify.error(error.response.statusText, 'Erreur ' + error.response.status, { timeout: 5000 });
        });
    }
  }
};
</script>
<style>
#inputsSMS {
  margin-bottom: 15px;
}
#messagePreview {
  background-color: lightblue;
  padding: 10px 10px 10px 15px;
  border-radius: 15px !important;
  margin-bottom: 15px;
  margin-left: 15px;
}
#messagePreview > p {
  margin: 0px;
}
#senderIcon {
  font-size: 16px;
  border-radius: 20px;
  padding: 0.7em;
  background-color: lightblue;
}
.snotify {
  z-index: 10057;
}
</style>
